import React, { useCallback, useState } from 'react';
import * as css from './ROHistoryCardPanelDetail.module.scss';
import { strings } from 'src/localization';
import { ROHistory, VehicleRec, ascCtaInteractionInput } from 'src/models';
// import { Link } from '@framework-controls/core';
import ROHistoryCardPanelDetailOp from 'src/components/ROHistoryCard/ROHistoryCardPanel/ROHistoryCardPanelDetail/ROHistoryCardPanelDetailOp/containers/ROHistoryCardPanelDetailOp';
import { ascCtaInteraction } from 'src/helpers/EventHelper/EventHelper';
// import Footer from 'src/components/Footer/Footer';

export interface IProps {
    histIndex: number;
    roHistory: ROHistory[];
    vehicles: VehicleRec[];
    selectedVehicle?: string;
}

const ROHistoryCardPanelDetail = (props: IProps) => {
    const [viewOp, setViewOp] = useState(0);

    const onMore = useCallback((e: any) => {
        if (
            (props.roHistory[props.histIndex].detail.length <= 2) ||
            (viewOp === (props.roHistory[props.histIndex].detail.length - 2))
        ) {
            return;
        }
        setViewOp(viewOp + 1);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'item',
            elementText: strings.More,
            elementColor: '',
            elementOrder: '',
            elementType: 'popup',
            elementSubType: 'selection_link',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [viewOp, props.histIndex, props.roHistory, props.vehicles, props.selectedVehicle]);

    const onPrevious = useCallback((e: any) => {
        if (viewOp === 0) {
            return;
        }
        setViewOp(viewOp - 1);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'item',
            elementText: strings.Previous,
            elementColor: '',
            elementOrder: '',
            elementType: 'popup',
            elementSubType: 'selection_link',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [viewOp, props.vehicles, props.selectedVehicle]);

    // to be added later
    // const onSave = useCallback(() => {
    //     const unused = true;
    //     if (unused) {
    //         return;
    //     }
    // }, []);

    const operations = props.roHistory[props.histIndex].detail.map(op => {
        const detailOpIndex = props.roHistory[props.histIndex].detail.findIndex(result => result.opCode === op.opCode);
        let hidePanel = false;
        if ((detailOpIndex > (viewOp + 1)) || (detailOpIndex < viewOp)) {
            hidePanel = true;
        }

        return <ROHistoryCardPanelDetailOp
            key={props.roHistory[props.histIndex].RO + op.opCode}
            histIndex={props.histIndex}
            opIndex={detailOpIndex}
            hidePanel={hidePanel}></ROHistoryCardPanelDetailOp>;
    });

    let prevButtonClass = css.previousButton;
    if (viewOp === 0) {
        prevButtonClass = css.previousButtonDisabled;
    }

    let moreButtonClass = css.moreButton;
    if (
        (props.roHistory[props.histIndex].detail.length <= 2) ||
        (viewOp === (props.roHistory[props.histIndex].detail.length - 2))
    ) {
        moreButtonClass = css.moreButtonDisabled;
    }

    return (
        <div>
            <div className={css.detail}>
                <div className={css.ro}>
                    {strings.RO}{' '}{props.roHistory[props.histIndex].RO}
                </div>
                <div className={css.lineWithLink}>
                    <div className={css.invoicedOn}>
                        {strings.ROOpenedOn}{' '}{props.roHistory[props.histIndex].date}
                    </div>
                    {/* Commented out until Online Service Documents are active. */}
                    {/* <Button tooltip={strings.SavePrintTip}> */}
                    {/* <Link
                        className={css.saveButton}
                        key={'saveButton'}
                        id={'saveButton'}
                    // onClick={() => onSave()}
                    >
                        {strings.PrintSave}
                    </Link> */}
                    {/* </Button> */}
                </div>
                <hr />
                <div className={css.detailGridRow}>
                    <div className={css.invoiceLit}>
                        {strings.InvoiceTotal}
                    </div>
                    <div className={css.advisorLit}>
                        {strings.Advisor}
                    </div>
                    <div className={css.invoiceAmt}>
                        {props.roHistory[props.histIndex].price}
                    </div>
                    <div className={css.advisor}>
                        {props.roHistory[props.histIndex].advisor}
                    </div>
                </div>
                <div className={css.opHeader}>
                    <span className={css.operations}>
                        {strings.Operations}
                    </span>
                    <div className={css.opButtons}>
                        <span
                            className={prevButtonClass}
                            id={'previousButton'}
                            onClick={(e: any) => onPrevious(e)}>
                            {strings.Previous}
                        </span>
                        <span
                            className={moreButtonClass}
                            id={'moreButton'}
                            onClick={(e: any) => onMore(e)}>
                            {strings.More}
                        </span>
                    </div>
                </div>
                <div className={operations.length === 1 ? css.opAreaSingleOp : css.opArea}>
                    {operations}
                </div>
            </div>
            {/* Commented out until Online Service Documents are active.  */}
            {/* <div className={css.detailFooter}>
                <Footer
                    id='detailFooter'
                    // handler={onSave}
                    // secondaryhandler={onSave}
                    handler={onMore}
                    secondaryhandler={onMore}
                    isDisabled={true}
                    message={strings.SavePrintInvoice} />
            </div> */}
        </div>
    );
};

export default ROHistoryCardPanelDetail;